import React from "react";
import Reveal from "./Reveal";

const ITEMS = [
    { n: "01", title: "Оберете план", desc: "Підписка одразу активна. Скасуйте у будь-який момент — без штрафів.", time: "~2 хвилини" },
    { n: "02", title: "Заповните анкету про бізнес", desc: "10 простих питань. Що продаєте, де, скільки хочете клієнтів.", time: "~8 хвилин" },
    { n: "03", title: "Отримаєте готову кампанію", desc: "AI підготує ключові слова, тексти і покрокову інструкцію.", time: "~10 хвилин" },
];

export const AfterRegistration = () => {
    return (
        <section className="section" data-testid="after-registration-section">
            <div className="container-mx">
                <Reveal>
                    <h2 className="font-display font-extrabold text-text-primary" style={{ fontSize: "clamp(32px, 4.5vw, 48px)", letterSpacing: "-0.02em" }}>
                        Що відбудеться одразу після реєстрації
                    </h2>
                    <p className="mt-4 text-lg text-secondary-c max-w-[560px]">
                        Без дзвінків, без менеджерів, без очікування.
                    </p>
                </Reveal>

                <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
                    {ITEMS.map((it, i) => (
                        <Reveal key={i} delay={i * 0.08}>
                            <div
                                data-testid={`after-card-${i}`}
                                className="glass glass-hover rounded-2xl p-7 h-full relative overflow-hidden"
                            >
                                <div className="deco-number">{it.n}</div>
                                <h3 className="mt-5 font-display font-bold text-2xl text-text-primary">{it.title}</h3>
                                <p className="mt-3 text-sm text-secondary-c leading-relaxed">{it.desc}</p>
                                <div className="mt-6 font-mono text-xs text-primary-c">{it.time}</div>
                            </div>
                        </Reveal>
                    ))}
                </div>

                <Reveal delay={0.3}>
                    <div className="mt-12 text-center">
                        <p className="text-secondary-c text-sm">Всього: 20 хвилин від реєстрації до запущеної реклами.</p>
                        <div className="mt-4 font-mono font-bold text-5xl text-primary-c">00:20:00</div>
                    </div>
                </Reveal>
            </div>
        </section>
    );
};

export default AfterRegistration;
